/* ============================================================
   pltx2-fitness-device.js
   §2 Pilatix App — Device hero
   - Picks the right video source by viewport width (mobile vs desktop)
   - Forces autoplay (muted, playsinline — required for iOS)
   - Landing animation: plays ONCE on first viewport entry, then stays.
     Doesn't replay on scroll up (matches Apple).
   - Video pauses when section leaves viewport (saves CPU/battery).
   - Per-instance scoped via [data-pltx2-fd-root]; safe with multiple instances.
   ============================================================ */
(function () {
  'use strict';

  function setupDevice(root) {
    var phone = root.querySelector('[data-pltx2-fd-phone]');
    var video = root.querySelector('[data-pltx2-fd-video]');
    if (!phone) return;

    // ---- Pick video source for current viewport (run once at init) ----
    var desktopUrl = root.getAttribute('data-video-desktop') || '';
    var mobileUrl  = root.getAttribute('data-video-mobile')  || desktopUrl;
    var pickedUrl  = (window.innerWidth < 735 && mobileUrl) ? mobileUrl : desktopUrl;
    if (pickedUrl && video) {
      var sourceEl = video.querySelector('source');
      if (sourceEl) sourceEl.setAttribute('src', pickedUrl);
      else          video.setAttribute('src', pickedUrl);
      video.load();
    }

    if (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('playsinline', 'true');
      video.setAttribute('webkit-playsinline', 'true');
    }

    function playVideo() {
      if (!video) return;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    // ---- Landing animation — plays ONCE on first viewport entry ----
    // Apple's actual behaviour: doesn't replay on scroll up. We track with
    // `hasLanded` and the .is-landed class stays once set.
    var hasLanded = false;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (!hasLanded) {
              hasLanded = true;
              phone.classList.add('is-landed');
            }
            playVideo();
          } else if (video) {
            video.pause();
          }
        });
      }, { threshold: 0.4 });
      io.observe(phone);
    } else {
      // no IO — just land + play immediately
      phone.classList.add('is-landed');
      playVideo();
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-pltx2-fd-root]');
    for (var i = 0; i < roots.length; i++) setupDevice(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify theme editor section reload so changes preview live
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-pltx2-fd-root]');
    if (root) setupDevice(root);
  });
})();
